/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { magazineOfTheMonthControllerCreate } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-create';
import { MagazineOfTheMonthControllerCreate$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-create';
import { magazineOfTheMonthControllerCreateMany } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-create-many';
import { MagazineOfTheMonthControllerCreateMany$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-create-many';
import { magazineOfTheMonthControllerDelete } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-delete';
import { MagazineOfTheMonthControllerDelete$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-delete';
import { magazineOfTheMonthControllerFindAll } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-find-all';
import { MagazineOfTheMonthControllerFindAll$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-find-all';
import { magazineOfTheMonthControllerFindById } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-find-by-id';
import { MagazineOfTheMonthControllerFindById$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-find-by-id';
import { magazineOfTheMonthControllerReorder } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-reorder';
import { MagazineOfTheMonthControllerReorder$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-reorder';
import { magazineOfTheMonthControllerSearch } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-search';
import { MagazineOfTheMonthControllerSearch$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-search';
import { magazineOfTheMonthControllerUpdate } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-update';
import { MagazineOfTheMonthControllerUpdate$Params } from '../fn/magazine-of-the-month/magazine-of-the-month-controller-update';
import { MagazineOfTheMonthDto } from '../models/magazine-of-the-month-dto';
import { PaginationDto } from '../models/pagination-dto';

@Injectable({ providedIn: 'root' })
export class MagazineOfTheMonthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `magazineOfTheMonthControllerSearch()` */
  static readonly MagazineOfTheMonthControllerSearchPath = '/api/magazineOfTheMonths/search';

  /**
   * MagazineOfTheMonth 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerSearch$Response(params: MagazineOfTheMonthControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return magazineOfTheMonthControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * MagazineOfTheMonth 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerSearch(params: MagazineOfTheMonthControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.magazineOfTheMonthControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerFindAll()` */
  static readonly MagazineOfTheMonthControllerFindAllPath = '/api/magazineOfTheMonths';

  /**
   * 모든 MagazineOfTheMonth 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerFindAll$Response(params?: MagazineOfTheMonthControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MagazineOfTheMonthDto>>> {
    return magazineOfTheMonthControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 MagazineOfTheMonth 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerFindAll(params?: MagazineOfTheMonthControllerFindAll$Params, context?: HttpContext): Observable<Array<MagazineOfTheMonthDto>> {
    return this.magazineOfTheMonthControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MagazineOfTheMonthDto>>): Array<MagazineOfTheMonthDto> => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerCreate()` */
  static readonly MagazineOfTheMonthControllerCreatePath = '/api/magazineOfTheMonths';

  /**
   * MagazineOfTheMonth 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerCreate$Response(params: MagazineOfTheMonthControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<MagazineOfTheMonthDto>> {
    return magazineOfTheMonthControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * MagazineOfTheMonth 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerCreate(params: MagazineOfTheMonthControllerCreate$Params, context?: HttpContext): Observable<MagazineOfTheMonthDto> {
    return this.magazineOfTheMonthControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<MagazineOfTheMonthDto>): MagazineOfTheMonthDto => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerFindById()` */
  static readonly MagazineOfTheMonthControllerFindByIdPath = '/api/magazineOfTheMonths/{id}';

  /**
   * MagazineOfTheMonth id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerFindById$Response(params: MagazineOfTheMonthControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<MagazineOfTheMonthDto>> {
    return magazineOfTheMonthControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * MagazineOfTheMonth id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerFindById(params: MagazineOfTheMonthControllerFindById$Params, context?: HttpContext): Observable<MagazineOfTheMonthDto> {
    return this.magazineOfTheMonthControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<MagazineOfTheMonthDto>): MagazineOfTheMonthDto => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerDelete()` */
  static readonly MagazineOfTheMonthControllerDeletePath = '/api/magazineOfTheMonths/{id}';

  /**
   * MagazineOfTheMonth 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerDelete$Response(params: MagazineOfTheMonthControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return magazineOfTheMonthControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * MagazineOfTheMonth 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  magazineOfTheMonthControllerDelete(params: MagazineOfTheMonthControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.magazineOfTheMonthControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerUpdate()` */
  static readonly MagazineOfTheMonthControllerUpdatePath = '/api/magazineOfTheMonths/{id}';

  /**
   * MagazineOfTheMonth 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerUpdate$Response(params: MagazineOfTheMonthControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<MagazineOfTheMonthDto>> {
    return magazineOfTheMonthControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * MagazineOfTheMonth 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerUpdate(params: MagazineOfTheMonthControllerUpdate$Params, context?: HttpContext): Observable<MagazineOfTheMonthDto> {
    return this.magazineOfTheMonthControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<MagazineOfTheMonthDto>): MagazineOfTheMonthDto => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerCreateMany()` */
  static readonly MagazineOfTheMonthControllerCreateManyPath = '/api/magazineOfTheMonths/batch';

  /**
   * 여러 MagazineOfTheMonth 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerCreateMany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerCreateMany$Response(params: MagazineOfTheMonthControllerCreateMany$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MagazineOfTheMonthDto>>> {
    return magazineOfTheMonthControllerCreateMany(this.http, this.rootUrl, params, context);
  }

  /**
   * 여러 MagazineOfTheMonth 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerCreateMany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerCreateMany(params: MagazineOfTheMonthControllerCreateMany$Params, context?: HttpContext): Observable<Array<MagazineOfTheMonthDto>> {
    return this.magazineOfTheMonthControllerCreateMany$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MagazineOfTheMonthDto>>): Array<MagazineOfTheMonthDto> => r.body)
    );
  }

  /** Path part for operation `magazineOfTheMonthControllerReorder()` */
  static readonly MagazineOfTheMonthControllerReorderPath = '/api/magazineOfTheMonths/reorder';

  /**
   * 순서 변경.
   *
   * 입력한 ID와 일치하는 이달의 매거진의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `magazineOfTheMonthControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerReorder$Response(params: MagazineOfTheMonthControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return magazineOfTheMonthControllerReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * 순서 변경.
   *
   * 입력한 ID와 일치하는 이달의 매거진의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `magazineOfTheMonthControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  magazineOfTheMonthControllerReorder(params: MagazineOfTheMonthControllerReorder$Params, context?: HttpContext): Observable<void> {
    return this.magazineOfTheMonthControllerReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
